export enum GtmEventType {
  AddToCart = 'add_to_cart',
  RemoveFromCart = 'remove_from_cart',
  ViewCart = 'view_cart',
  ViewItem = 'view_item',
  BeginCheckout = 'begin_checkout',
  LoginCheckout = 'login_checkout',
  JssLeadFormSubmitted = 'jss_lead_form_submitted',
  Search = 'search',
}
